import { message } from 'ant-design-vue';
import axios from 'axios';
import Cookies from 'js-cookie';

import store from '../store';

const service = axios.create({
  timeout: 600000,
});

// 当前是否已在首页：首页再跳 /index 会触发浏览器刷新，可能形成刷新循环
const isHomePage = () => {
  const pathname = window.location.pathname.replace(/\/+$/, '');
  return pathname === '' || pathname.endsWith('/index') || pathname.endsWith('/index.html');
};

service.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('request: ', error); // for debug
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 登录态失效 / 被其他设备顶掉：清掉本地 token 再跳首页
    // 注意：只有在“本地原本有 token”时才提示并跳转。
    // 清 token 后并发的后续请求必然也返回 2000，若每次都跳转，
    // 在首页时 href 指向当前地址会触发刷新 → 请求再失败 → 再刷新，形成无限闪屏。
    if (res.code == 2000) {
      const hadToken = !!store.getters.getToken;
      Cookies.remove('token');
      store.dispatch('logout');
      if (hadToken) {
        message.warning('Your session has expired, please log in again.');
        if (!isHomePage()) {
          window.location.href = '/index';
        }
      }
      return Promise.reject(res);
    } else if (res.code == 30007) {
      // 同样避免在首页重复跳转自身地址造成刷新循环
      if (!isHomePage()) {
        window.location.href = '/index';
      }
      return Promise.reject(res);
    }
    // 兜底：后端有时返回空 msg，避免前端 message.error(res.msg) 弹出空白提示
    if (res.code != 0 && !res.msg) {
      res.msg = 'Request failed, please try again.';
    }
    return res;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      message.error('Request timed out...');
    }
    console.error('response error:', error);
    return Promise.reject(error);
  }
);

export default service;
